import { navigate, NavigateOptions } from "@gatsbyjs/reach-router";
import { showErrorDialog } from "ap-components";

export function launchPage(to: string, options?: NavigateOptions<{}>) {
    setTimeout(() => { navigate(to, options) })
}

export function handleErrorMessage(error: unknown) {
    let errorMessage = "Failed to do something exceptional";
    if (error instanceof Error) {
        errorMessage = error.message;
    }
    showErrorDialog(errorMessage);
}

export const IFSC_REGEX = /^[A-Z]{4}0[A-Z0-9]{6}$/;
export const ADDRESS_REGEX = /^[\d\w ]*$/;

const getBase64 = (file: Blob) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
});

export async function convertBase64(file: Blob) {
    return await getBase64(file) as ArrayBuffer | string | null
}

export function convertSum(input: string) {
    if (input === '' || typeof input !== 'string') {
        return;
    }
    // Remove commas and convert to a numeric value
    const number = parseFloat(input.replace(/,/g, ''));

    if (isNaN(number)) {
        return 'Invalid input';
    }

    if (number < 1000) {
        return number.toString();
    }

    if (number >= 10000000) {
        const crore = (number / 10000000).toFixed(0);
        return `₹${crore} crore${parseFloat(crore) > 1 ? 's' : ''}`;
    } else if (number >= 100000) {
        const lakh = (number / 100000).toFixed(0);
        return `₹${lakh} lakh${parseFloat(lakh) > 1 ? 's' : ''}`;
    } else if (number >= 1000) {
        const thousand = (number / 1000).toFixed(0);
        return `₹${thousand} thousand${parseFloat(thousand) > 1 ? 's' : ''}`;
    } else {
        return number.toString();
    }
}
export const neftBeneficiaryDetails = [
    {
        "provider": "MAHINDRA",
        "beneficiaryName": "MMFSL FIXED DEPOSIT",
        "accNumber": "02400310004199",
        "bank": "HDFC BANK",
        "micrCode": "400211002",
        "ifscCode": "HDFC0000240",
    },
    {
        "provider": "BAJAJ",
        "beneficiaryName": "Bajaj Finance Ltd Fixed Deposit Coll Ac",
        "accNumber": "BFLFD8",
        "bank": "HDFC Bank Ltd, Kanjurmarg, Mumbai",
        "micrCode": "4989",
        "ifscCode": "HDFC0004989",
    }
]
export function getCroppedImage({ image, crop, rotate = 0 }: { image: any, crop: { [key: string]: any }, rotate: number }) {
    const TO_RADIANS = Math.PI / 180
    // const scale = 1;
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d')

    if (!ctx) {
        throw new Error('No 2d context')
    }

    const scaleX = image.naturalWidth / image.width
    const scaleY = image.naturalHeight / image.height
    // devicePixelRatio slightly increases sharpness on retina devices
    // at the expense of slightly slower render times and needing to
    // size the image back down if you want to download/upload and be
    // true to the images natural size.
    const pixelRatio = window.devicePixelRatio
    // const pixelRatio = 1

    canvas.width = Math.floor(crop.width * scaleX * pixelRatio)
    canvas.height = Math.floor(crop.height * scaleY * pixelRatio)

    ctx.scale(pixelRatio, pixelRatio)
    // ctx.imageSmoothingQuality = 'high'

    const cropX = crop.x * scaleX
    const cropY = crop.y * scaleY

    const rotateRads = rotate * TO_RADIANS
    const centerX = image.naturalWidth / 2
    const centerY = image.naturalHeight / 2

    ctx.save()

    // 5) Move the crop origin to the canvas origin (0,0)
    ctx.translate(-cropX, -cropY)
    // 4) Move the origin to the center of the original position
    ctx.translate(centerX, centerY)
    // 3) Rotate around the origin
    ctx.rotate(rotateRads)
    // 2) Scale the image
    // ctx.scale(scale, scale)
    // 1) Move the center of the image to the origin (0,0)
    ctx.translate(-centerX, -centerY)
    ctx.drawImage(
        image,
        0,
        0,
        image.naturalWidth,
        image.naturalHeight,
        0,
        0,
        image.naturalWidth,
        image.naturalHeight,
    )

    ctx.restore()

    return new Promise((resolve, reject) => {
        // var response = canvas.toDataURL("image/jpeg", 1)
        // resolve(response)
        canvas.toBlob(
            async (blob) => {
                if (!blob) {
                    //reject(new Error('Canvas is empty'));
                    console.error('Canvas is empty');
                    return;
                }
                var base64 = await convertBase64(blob);
                resolve(base64);
            },
            'image/jpeg',
            0.75
        );
    });

}
export const customerCategoryOptions = [
    {
        name: "Shareholder of BFL", id: "Shareholder"
    },
    {
        name: "Relative of Director of BFL", id: "Relative of Director"
    },
    {
        name: "Director or Promoter of BFL", id: "Director or Promoter of BFL"
    },
    {
        name: "None of the Above", id: "None of the Above"
    },
]
export const LOCALE_REGEX = {
    IFSC: /^[A-Z]{4}0[A-Z0-9]{6}$/,
    GSTIN: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/,
    ACCOUNT_NUMBER: /^\d{9,18}$/,
    ARN: /^ARN-\d{2,7}$/,
    CHEQUE_NUMBER: /^\d{6}$/,
    PRAN: /^\d{12}$/
}
